import { Form, Formik } from "formik";
import React from "react";
import Button from "../Button/button.component";

export const BuscaAvancadaContext = React.createContext({
	errors: null,
	touched: null,
	values: null,
	handleChange: null,
	setFieldValue: null,
	resetForm: null
});

const BuscaAvancada = props => {
	const {
		children,
		handleSearch,
		initialValues,
		handlePesquisaSimplificada,
		handleClear,
		buttonLabel
	} = props;

	return (
		<React.Fragment>
			<Formik
				enableReinitialize
				initialValues={initialValues || []}
				onSubmit={handleSearch}
			>
				{ctx => (
					<Form>
						<BuscaAvancadaContext.Provider value={ctx}>
							<div>{children}</div>
							<div className="row">
								<div className="col-6 mt-3 mb-2">
									<button
										type="button"
										onClick={handlePesquisaSimplificada}
										className="btn btn-link pl-0"
									>
										{buttonLabel
											? buttonLabel
											: "Pesquisa simplificada"}
									</button>
								</div>
								<div className="col-6 text-right mt-3">
									<Button
										type="button"
										default
										icon="fa fa-times"
										onClick={() => handleClear(ctx)}
									>
										Limpar
									</Button>
									<Button
										type="submit"
										primary
										icon="fa fa-search"
									>
										{" "}
										Pesquisar{" "}
									</Button>
								</div>
							</div>
						</BuscaAvancadaContext.Provider>
					</Form>
				)}
			</Formik>
		</React.Fragment>
	);
};

export default BuscaAvancada;
